"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var MobilePaymentsInfo_1 = __importDefault(require("../MobilePaymentsInfo"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MobileAuthButtons = function (_a) {
    var _b = _a.showSignUp, showSignUp = _b === void 0 ? true : _b;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var openSignIn = (0, apps_shared_1.useOpenSignIn)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var isLoading = (0, swr_hooks_1.useUser)().isLoading;
    if (isLoading ||
        isAuth ||
        Object.keys(breakpoints).length === 0 ||
        !breakpoints.mobile)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement(MobilePaymentsInfo_1.default, null),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: openSignIn, width: "100%", maxWidth: "100%" }, t('login')),
            showSignUp && (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: openSignUp, width: "100%", maxWidth: "100%" }, t('signup'))))));
};
exports.default = MobileAuthButtons;
